import { NavigationMenu as BaseNavigationMenu } from "@base-ui-components/react/navigation-menu";
import {
  navigationMenuLinkClasses,
  navigationMenuTriggerClasses,
} from "./NavigationMenu.style";
import { createContext, useContext } from "react";

// Create a context to track if we're inside NavigationMenuContent
const NavigationMenuContentContext = createContext(false);

// Export the context provider for use in NavigationMenuContent
export const NavigationMenuContentProvider =
  NavigationMenuContentContext.Provider;

const NavigationMenuLink = (props: BaseNavigationMenu.Link.Props) => {
  const { className, ...others } = props;
  // Use the context to determine if we're inside NavigationMenuContent
  const isInContent = useContext(NavigationMenuContentContext);
  const resolvedClassName =
    typeof className === "function" ? className({ active: false }) : className;
  return (
    <BaseNavigationMenu.Link
      {...others}
      className={
        isInContent
          ? navigationMenuLinkClasses({ className: resolvedClassName })
          : navigationMenuTriggerClasses({ className: resolvedClassName })
      }
    />
  );
};

export default NavigationMenuLink;
